
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'

const ApSimDark = {
  dark: true,
  colors:{
    primary: '#4a7099',      // Lighter blue for dark mode
    secondary: '#5bb3e1',    // Light blue accent
    accent: '#e94f3a',       // Red accent
    error: '#FF5252',
    info: '#5bb3e1',
    success: '#4CAF50',
    warning: '#f5b938',      // Yellow from branding
    background: '#0d1117',   // Dark background
    surface: '#161b22',      // Card/surface background
  }
}

const ApSimLight = {
  dark: false,
  colors:{
    primary: '#2c4a6b',      // Dark blue from branding
    secondary: '#3ba3d1',    // Light blue from branding
    accent: '#e94f3a',       // Red accent from branding
    error: '#FF5252',
    info: '#3ba3d1',
    success: '#4CAF50',
    warning: '#f5b938',      // Yellow from branding
    background: '#f5f7fa',   // Light background
    surface: '#ffffff',      // Card/surface background
  }
}

const defaultTheme = 'ApSimLight'; 

//check system theme 
// if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
//   defaultTheme = 'ApSimLight';
// } 

const vuetify = createVuetify({
    ssr: false,
    defaults:{
      VBtn: { variant: 'outlined' },
      VCard: { outlined: true },
    },
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      }
    },
    theme: {

        defaultTheme: defaultTheme,
        themes:{
          ApSimDark,
          ApSimLight
        }
    },
    components,
    directives,
  })

export default vuetify;